import { Component, h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import classNames from 'classnames'
import axios from 'axios'

interface User {
    id: number,
    name: string,
    avatar: string,
    points: number,
    leaderboardPosition: number,
    rank?: string
}

interface State {
    usersList: Array<User>,
    isLoading: boolean
}

interface Props {
    maxResults: number,
    excludeUserRole: Array<string>,
    tabTitle: string,
    key: string,
    emptyMessage: string,
    isPreviewEmptyMessage?: boolean
}

const minUsersRequiredOnLeaderboard = 3
const topLeaderboardUsers = 3

class LeaderboardUserList extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      usersList: [],
      isLoading: false
    }
  }

  async componentDidMount () {
    this.setState({ isLoading: true })
    try {
      const res = await axios.get('/widget/pointsLeaderboard', {
        params: {
          period: this.props.tabTitle,
          maxResults: this.props.maxResults,
          excludeRoles: this.props.excludeUserRole.join(',')
        }
      })
      if (res.data) {
        this.setState({ usersList: res.data, isLoading: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render (props: Props, state: State) {
    return (
      <div className='leaderboard-tab'>
        {
          state.isLoading ? '' : (state.usersList.length > minUsersRequiredOnLeaderboard && !props.isPreviewEmptyMessage ? (
            <table>
              { state.usersList.map(user => <LeaderboardUserRow {...user} />)}
            </table>
          ) : <div className='default-leaderboard-meta-text' dangerouslySetInnerHTML={{ __html: props.emptyMessage }} />
          ) }
      </div>
    )
  }
}

const LeaderboardUserRow = ({ id, name, avatar, points, leaderboardPosition, rank }: User) => {
  let userData = {
    id: id,
    name: name,
    avatar: avatar,
    rank: {
      avatarIconUrl: rank
    }
  }
  return (
    <tr className='leaderboard-row'>
      <td className='leaderboard-user-position'><LeaderboardPosition leaderboardPosition={leaderboardPosition} /></td>
      <td className='leaderboard-user-avatar'><UserAvatar user={userData} showRank /></td>
      <td className='leaderboard-username'>
        <div>
          <UserName user={userData} extraClass='username' />
          <p className='text--meta leaderboard-user-points'>{points} Points</p>
        </div>
      </td>
    </tr>
  )
}

const LeaderboardPosition = ({ leaderboardPosition }: { leaderboardPosition: number}) => {
  const isTopThree = leaderboardPosition <= topLeaderboardUsers
  return (
    <div className='position-container'>
      <div className='position-background'>
        <div className={classNames('position-number', isTopThree ? 'position-number-top' : 'position-number-other')}
        >{leaderboardPosition}</div>
      </div>
    </div>
  )
}

export default LeaderboardUserList
